import { LitElement, html, css } from "lit-element";
import { customElement, property } from "lit/decorators.js";
import "./chat-history";
import GameApp from "../../index";
import { Scene } from "excalibur";
import AsyncEventDispatcher from "@/utils/event-dispatcher";
import gameApp from "../../index";

@customElement("top-bar")
export class TopBar extends LitElement {
  public zoomLevel: number = 100;
  @property() public coinCount: number = 0;

  constructor() {
    super();

    const userData = localStorage.getItem("tam_user");
    this.coinCount = userData ? JSON.parse(userData).coins : 0;

    AsyncEventDispatcher.getInstance().addEventListener(
      "coin-update",
      this.handleCoinUpdate
    );
  }

  // Clean up event listener when element is removed
  disconnectedCallback() {
    super.disconnectedCallback();

    AsyncEventDispatcher.getInstance().removeEventListener(
      "coin-update",
      this.handleCoinUpdate
    );
  }

  private handleCoinUpdate = (event: CustomEvent) => {
    const { coins, action } = event.detail;

    switch (action) {
      case "increase":
        this.coinCount += coins;
        break;
      case "decrease":
        this.coinCount = Math.max(0, this.coinCount - coins);
        break;
      default:
        this.coinCount = coins;
        break;
    }

    this.requestUpdate();
  };

  protected createRenderRoot() {
    return this;
  }

  public updateZoomLevel() {
    // Ensure zoomLevel is a rounded and formatted percentage
    this.zoomLevel = Math.round((gameApp.dashboard?.getCameraZoom() || 0) * 100);

    this.requestUpdate();
  }

  private increaseZoom() {
    const scene = GameApp.game.currentScene as Scene;
    if (this.zoomLevel < 200 && scene) {
      gameApp.dashboard?.zoomIn();
      this.updateZoomLevel();
    }
  }

  private decreaseZoom() {
    if (this.zoomLevel > 50) {
      gameApp.dashboard?.zoomOut();
      this.updateZoomLevel();
    }
  }

  render() {
    return html`
      <div class="top-bar">
        <img src="public/gui/coin.png" witdth="18" height="18" alt="Coin" />
        <span class="text-gold">${this.coinCount || 0}</span>
        <!-- Dynamically display coin count -->
        <div class="zoom-controls">
          <button @click="${this.decreaseZoom}" class="btn is-compact">-</button>
          <span class="text-gold">${this.zoomLevel}%</span>
          <button @click="${this.increaseZoom}" class="btn is-compact">+</button>
        </div>
      </div>
    `;
  }
}
